const format = (s: string) => {
  return String(s).slice(0, 10).replace(/-/g, '.');
};

export const Date: React.FC<{ dateString?: string | null }> = ({
  dateString,
}) =>
  dateString ? <time dateTime={dateString}>{format(dateString)}</time> : null;
